var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C4.05 18 0 13.95 0 9C0 4.05 4.05 0 9 0C13.95 0 18 4.05 18 9C18 13.95 13.95 18 9 18ZM9 1.5C4.875 1.5 1.5 4.875 1.5 9C1.5 13.125 4.875 16.5 9 16.5C13.125 16.5 16.5 13.125 16.5 9C16.5 4.875 13.125 1.5 9 1.5Z",
    fill: "#0033CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24999 13.5C7.94999 13.5 7.72499 13.35 7.49999 13.125C7.12499 12.6 7.42499 11.85 8.24999 9.825C8.39999 9.525 8.54999 9.15 8.69999 8.85C8.39999 9.075 7.94999 9.075 7.64999 8.775C7.34999 8.475 7.34999 8.025 7.64999 7.725C7.79999 7.65 8.69999 6.75 9.74999 6.75C10.05 6.75 10.275 6.9 10.5 7.125C10.875 7.65 10.575 8.4 9.74999 10.425C9.59999 10.725 9.44999 11.1 9.29999 11.4C9.59999 11.175 10.05 11.175 10.35 11.475C10.65 11.775 10.65 12.225 10.35 12.525C10.2 12.6 9.29999 13.5 8.24999 13.5Z",
    fill: "#0033CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.125 6C10.7463 6 11.25 5.49632 11.25 4.875C11.25 4.25368 10.7463 3.75 10.125 3.75C9.50368 3.75 9 4.25368 9 4.875C9 5.49632 9.50368 6 10.125 6Z",
    fill: "#0033CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.125 6.375C9.3 6.375 8.625 5.7 8.625 4.875C8.625 4.05 9.3 3.375 10.125 3.375C10.95 3.375 11.625 4.05 11.625 4.875C11.625 5.7 10.95 6.375 10.125 6.375ZM10.125 4.125C9.675 4.125 9.375 4.425 9.375 4.875C9.375 5.325 9.675 5.625 10.125 5.625C10.575 5.625 10.875 5.325 10.875 4.875C10.875 4.425 10.575 4.125 10.125 4.125Z",
    fill: "#0033CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d4fe3ebb5974f1c00240c9d089a1e8c9.svg";
export { ForwardRef as ReactComponent };